var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel-primary page",
    attrs: {
      "id": "formBox"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.checking) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-muted",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Checking reset link…")])]) : (_vm.done) ? [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-footer text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.go_to_login($event)
      }
    }
  }, [_vm._v("Go to login")])])] : (_vm.invalid_reason) ? [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.invalid_message) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.go_to_login($event)
      }
    }
  }, [_vm._v("Go to login")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.go_to_forgot($event)
      }
    }
  }, [_vm._v("Request a new reset")])])] : _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "novalidate": "",
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send_reset($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "New Password",
      "disabled": _vm.submitting
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_confirm),
      expression: "password_confirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password",
      "disabled": _vm.submitting
    },
    domProps: {
      "value": (_vm.password_confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_confirm = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.submitting
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitting ? "Saving..." : "Change Password") + "\n        ")])])])], 2)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "2em 0 1em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/logo.png"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('span', {
    staticClass: "panel-title"
  }, [_vm._v("Change Password")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('strong', [_vm._v("Password updated.")]), _vm._v("\n          Your password has been changed. You can now sign in with your new password.\n        ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ccfafe","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/PasswordReset.vue
// module id = 560
// module chunks = 0